import { useCallback } from 'react';
import axios from 'axios';
import { REACT_APP_ENV_URL, Endpoints } from '../../const';

export const useAnalyticsData = () => {
  const updateAnalyticsData = useCallback(async (reqBody, intakeId) => {
    await axios
      .put(`${REACT_APP_ENV_URL}${Endpoints.UPDATE_ANALYTICS_DATA}`, { ...reqBody }, { params: { intakeId } })
      .then(result => {
        JSON.stringify(result, null, 2);
        // eslint-disable-next-line no-console
        console.log('Success Message :: ANALYTICS_DATA_UPDATED_SUCCESSFULLY!');
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.log(error, null, 2);
        // eslint-disable-next-line no-console
        console.log('Error :: ANALYTICS_DATA_UPDATION_FAILED!');
      });
  }, []);

  return {
    updateAnalyticsData,
  };
};
